import { ReactNode } from 'react';
import { TFunction } from 'i18next';
import Separator from 'assets/icons/divider_vertical.svg';
import Phone from 'assets/icons/local_phone.svg';
import Mail from 'assets/icons/mail.svg';
import { Skeleton } from 'syngenta-digital-cropwise-react-ui-kit';

interface NonDDGUserDetailsProps {
  nonDDGUserDetails: {
    first_name?: string | null;
    last_name?: string | null;
    phone?: string | null;
    email?: string | null;
  } | null;
  isMobile: boolean;
  t: TFunction;
  children: (content: ReactNode) => ReactNode;
}

export const NonDDGUserDetails = ({
  nonDDGUserDetails,
  isMobile,
  t,
  children,
}: NonDDGUserDetailsProps): JSX.Element => {
  const content = (
    <>
      <div style={{ textAlign: 'left' }}>
        {nonDDGUserDetails?.first_name ? (
          <>
            {`${t('By')}: ${nonDDGUserDetails?.first_name || ''} ${
              nonDDGUserDetails?.last_name || ''
            }`}
            {!isMobile && <img src={Separator} alt="No img found" className="separator-icon" />}
          </>
        ) : (
          <Skeleton.Button active size={'default'} shape={'default'} block={false} />
        )}
      </div>
      <div className={isMobile ? 'user-details-mobile' : 'user-details-desktop'}>
        {!!nonDDGUserDetails?.phone && (
          <div className={isMobile ? 'contact-details-mobile' : 'contact-details-desktop'}>
            <img src={Phone} alt="No img found" className="icon-padding" />
            <div className={isMobile ? 'user-details-text' : ''}>
              {nonDDGUserDetails?.email ? (
                <a className="text-link" href={`tel:+${nonDDGUserDetails?.phone}`}>
                  {nonDDGUserDetails?.phone}
                </a>
              ) : (
                <Skeleton.Button active size={'default'} shape={'default'} block={false} />
              )}
            </div>
            <img src={Separator} alt="No img found" className="separator-icon" />
          </div>
        )}
        <div className={isMobile ? 'contact-details-mobile' : 'contact-details-desktop'}>
          <img src={Mail} alt="No img found" className="icon-padding" />
          <div className={isMobile ? 'user-details-text' : ''}>
            {nonDDGUserDetails?.email ? (
              <a className="text-link" href={`mailto:${nonDDGUserDetails?.email}`}>
                {nonDDGUserDetails?.email}
              </a>
            ) : (
              <Skeleton.Button active size={'default'} shape={'default'} block={false} />
            )}
          </div>
        </div>
      </div>
    </>
  );

  return <>{children(content)}</>;
};
